// extracted by extract-css-chunks-webpack-plugin
module.exports = {"shelf":"app-components-staticpages-blocks-collectionsblock--shelf"};